<div class="error-container">
    <h1>Error 404 - Página no encontrada</h1>
    <p>No pudimos validar tu acceso.</p>
    <p>Serás redirigido al login en <span id="countdown">{{ countdown }}</span> segundos...</p>
    <button (click)="onLoginNowClick()">Ir al Login Ahora</button>
  </div>
  